import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import HowItWorks from './components/HowItWorks/HowItWorks';
import Benefits from './components/Benefits/Benefits';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

const Home = () => {
    return (
        <>
            <Header />
            <main>
                <Hero />
                <HowItWorks />
                <Benefits />
                <Contact />
            </main>
            <Footer />
        </>
    )
}

export default Home;
